"use client"

import { useEffect, useState } from "react"

export type ViewMode = "chart" | "table"

const STORAGE_PREFIX = "market-status-view:"
const AUTO_TABLE_THRESHOLD = 5 // 보유 일수가 이 미만이면 테이블을 기본값으로

// 사용자가 직접 토글한 적이 있으면 그 선택을 localStorage에서 그대로 따르고,
// 아직 한 번도 토글하지 않았다면 데이터 개수 기준으로 매번 자동 결정한다
// (데이터가 쌓여서 임계값을 넘으면 자동으로 차트 기본값으로 바뀌도록).
export function useViewMode(key: string, dataCount: number): [ViewMode, (mode: ViewMode) => void] {
  const storageKey = STORAGE_PREFIX + key
  const [mode, setMode] = useState<ViewMode | null>(null)

  useEffect(() => {
    if (mode !== null) return
    if (dataCount === 0) return // 데이터 로딩 전에는 기본값 확정을 미룬다

    const stored = window.localStorage.getItem(storageKey)
    if (stored === "chart" || stored === "table") {
      setMode(stored)
    } else {
      setMode(dataCount < AUTO_TABLE_THRESHOLD ? "table" : "chart")
    }
  }, [dataCount, mode, storageKey])

  const setModeAndPersist = (next: ViewMode) => {
    setMode(next)
    window.localStorage.setItem(storageKey, next)
  }

  return [mode ?? "chart", setModeAndPersist]
}
